(function () {
    'use strict';

    angular
        .module('ipmApp')
        .directive('psychIntakeMedicationsComponent', psychIntakeMedicationsComponent);

    psychIntakeMedicationsComponent.$inject = [];

    function psychIntakeMedicationsComponent() {
        var directive = {
            restrict: 'EA',
            scope: {
                workflow: '='
            },
            link: linkFunc,
            controller: DirectivePsychIntakeMedicationsController,
            templateUrl: 'app/psych-intake/workflow/partial/directive/medications.directive.html',
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        }
    }

    DirectivePsychIntakeMedicationsController.$inject = ['$scope', '$stateParams', '$element'];
    function DirectivePsychIntakeMedicationsController($scope, $stateParams, $element) {
        var vm = this;
        
        function init() {
        }

        init();
    }
})();
